import React, { Component } from 'react';
import {
	Nav, NavLink, Row,
	Navbar, NavItem, DropdownItem
} from 'reactstrap';
import PropTypes from 'prop-types';
import MegaMenuHover from '../../views/Productos/MegaMenu.js';
import './styles.scss';
import api from "../../api";
import apifunctions from "../../api/functions.js";

class ParadigmaHeaderMenu extends Component {
	constructor(props) {
		super(props);
		let Menues = this.props.Menues;

		this.toggle = this.toggle.bind(this);
		this.handleMediaQueryChange = this.handleMediaQueryChange.bind(this);

		this.state = {
			Menues: (Menues ? Menues : []),
			dropdownOpen: false,
			filters: [],
			loading: true,
			isHovered: false,
			isMobile: window.matchMedia('(max-width: 1300px)').matches
		};

		this.mediaQueryList = window.matchMedia('(max-width: 1300px)');
	}

	toggle() {
		this.setState({
			dropdownOpen: !this.state.dropdownOpen
		});
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.Menues !== this.props.Menues) {
			this.setState(prevState => {
				prevState.Menues = nextProps.Menues;
				return prevState;
			});
		}
	}

	componentDidMount() {
		// Llamar a `getFilters` con los parámetros deseados para cargar los filtros
		this.getFilters('productos', '', '', '', '', '', 40, 0);
		this.mediaQueryList.addEventListener('change', this.handleMediaQueryChange);
	}

	getFilters(principal, filter, sort, priceMin, priceMax, search, pageSize, page = 0) {
		let filters = priceMin && priceMax ? ["price[gte]=" + priceMin, "price[lte]=" + priceMax] : [];
		if (search !== '') {
			filters.push("search=" + search);
		}

		// Realizar la llamada API
		apifunctions.get((api.api.productos) +
			(principal ? principal + "/" + (filter ? filter + "/" : "") : ""), null, 1, {
				sort: sort ? [sort] : null,
				pageSize: pageSize ? [pageSize] : 40,
				filters: filters,
				page: page
			},
			(response) => {
				if (response && response.data.filters) {
					this.setState({
						filters: response.data.filters,
						loading: false
					});
				}
			},
			() => {
				console.error("Error al obtener filtros");
				this.setState({ loading: false });
			}
		);
	}

	static propTypes = {
		Menues: PropTypes.array,
		onMenuWillOpen: PropTypes.func,
		onMenuOpened: PropTypes.func,
		onMenuWillClose: PropTypes.func,
		onMenuClosed: PropTypes.func,
		dropdownOpen: PropTypes.bool
	}

	handleChangeFilter = ({ identifier, code }) => {
		// console.log(`Filtro cambiado: ${identifier}, ${code}`);
	}

	handleMouseEnter = () => {
        this.setState({ isHovered: true });
    }

    handleMouseLeave = () => {
        this.setState({ isHovered: false });
    }

	componentWillUnmount() {
		this.mediaQueryList.removeEventListener('change', this.handleMediaQueryChange);
	}

	handleMediaQueryChange(event) {
		this.setState({ isMobile: event.matches });
	}

	render() {
		let { Menues, filters, isHovered, isMobile  } = this.state;

		return (
			<Row className="no-margin-row">
				<Nav className="m-auto navbar-main d-flex justify-content-center">
					<NavItem>
						<NavLink href="/#/" active className="custom-nav-link">Inicio</NavLink>
					</NavItem>
					{
						Menues && Menues.length === 1 ? (
							<React.Fragment>
								<NavItem
									onMouseEnter={this.handleMouseEnter}
									onMouseLeave={this.handleMouseLeave}>
									<NavLink
										href={`#${Menues[0].href}`}
										className="custom-nav-link"
									>
										Productos
									</NavLink>
									{!isMobile && isHovered && (
										<MegaMenuHover
											filters={filters || []}
											onChangeFilter={this.handleChangeFilter}
										/>
									)}
								</NavItem>
								<NavItem>
									<NavLink className="custom-nav-link" href={`#${Menues[0].href.replace("productos", "ofertas")}` }>Ofertas</NavLink>
								</NavItem>
							</React.Fragment>
						) : null
					}
					<NavItem>
						<NavLink href="/#/empresa/" className="custom-nav-link">La empresa</NavLink>
					</NavItem>
					<NavItem>
						<NavLink href="/#/novedades/" className="custom-nav-link">Novedades</NavLink>
					</NavItem>
					<NavItem>
						<NavLink href="/#/contacto/" className="custom-nav-link">Contacto</NavLink>
					</NavItem>
				</Nav>
			</Row>
		);
	}
}

export default ParadigmaHeaderMenu;



// WEBPACK FOOTER //
// ./src/components/ParadigmaHeaderMenu/ParadigmaHeaderMenu.js